'use client';
import { useEffect } from 'react';
import { shouldUseYotpoReviews } from '@/utils/helpers';
import { loadYotpoScript, refreshYotpoWidgets } from '@/utils/loadYotpoScript';
import { useNavigationEvent } from './useNavigationEvent';

export const useYotpoScript = () => {
  useEffect(() => {
    if (!shouldUseYotpoReviews()) return;

    // Load the script and then refresh widgets once loaded
    loadYotpoScript().then(() => {
      refreshYotpoWidgets();
    });

    // Refresh widgets after component mounts and DOM is stable
    const refreshTimeout = setTimeout(() => {
      refreshYotpoWidgets();
    }, 1000);

    return () => clearTimeout(refreshTimeout);
  }, []);

  // Refresh Yotpo widgets on navigation events
  useNavigationEvent(() => {
    if (!shouldUseYotpoReviews()) return;
    setTimeout(() => {
      refreshYotpoWidgets();
    }, 100);
  });
};
